import * as React from 'react';
import { SVGProps } from 'react';

const SvgCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#calendar_svg__a)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.5 3h3A1.502 1.502 0 0 1 21 4.5v15a1.502 1.502 0 0 1-1.5 1.5h-15A1.502 1.502 0 0 1 3 19.5v-15A1.502 1.502 0 0 1 4.5 3h3V1.5H9V3h6V1.5h1.5V3Zm-9 1.5h-3v3h15v-3h-3V6H15V4.5H9V6H7.5V4.5ZM8.25 9H4.5v4.5h3.75V9Zm1.5 10.5h4.5V15h-4.5v4.5Zm0-6h4.5V9h-4.5v4.5Zm6 1.5v4.5h3.75V15h-3.75Zm3.75-6h-3.75v4.5h3.75V9Zm-15 6h3.75v4.5H4.5V15Zm8.25 1.5h-1.5V18h1.5v-1.5Z'
        fill='#000'
      />
    </g>
    <defs>
      <clipPath id='calendar_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgCalendar;
